import ts from 'typescript'

const bootstrapComSource = (code: string) => `async function(...params) { 
  ${code}
  return main(...params)
}`

export const getComSource = (source: string) => {
  let compileSource = ts.transpileModule(source, {
    compilerOptions: {
      target: ts.ScriptTarget.ES2016,
      module: ts.ModuleKind.CommonJS,
      noEmit: true,
    },
  })

  if (compileSource.outputText) {
    const code = compileSource.outputText
    const funIndex = code.indexOf('function main(')

    if (funIndex < 0) {
      throw new Error('main function not found')
    }

    return bootstrapComSource(code)
  }

  return ""
}
